import styled, { css } from 'styled-components';
import { atomicBlockContainerWidth, borderRadius, colorUsage, fontSize, fontWeight, getSpacing, horizontalScrollBar } from 'stylesheet';
var slideWidth = '200px';
var slideHeight = '220px';
var imageHeight = '140px';
var LoaderContainer = styled.div.withConfig({
  displayName: "AffiliationBlockSlideshowstyle__LoaderContainer",
  componentId: "sc-qo27jb-0"
})(["display:flex;justify-content:center;width:", ";height:140px;margin:", ";"], atomicBlockContainerWidth, getSpacing(1));
var AffiliationSlideshowTitle = styled.span.withConfig({
  displayName: "AffiliationBlockSlideshowstyle__AffiliationSlideshowTitle",
  componentId: "sc-qo27jb-1"
})(["display:block;font-weight:", ";font-size:", ";"], fontWeight.bold, fontSize.large);
var AffiliationSlideshow = styled.div.withConfig({
  displayName: "AffiliationBlockSlideshowstyle__AffiliationSlideshow",
  componentId: "sc-qo27jb-2"
})(["white-space:nowrap;", ""], horizontalScrollBar);
var AffiliationSlide = styled.div.withConfig({
  displayName: "AffiliationBlockSlideshowstyle__AffiliationSlide",
  componentId: "sc-qo27jb-3"
})(["position:relative;display:inline-block;width:", ";height:", ";margin-right:", ";"], slideWidth, slideHeight, getSpacing(1));
var AffiliationSlideImageContainer = styled.div.withConfig({
  displayName: "AffiliationBlockSlideshowstyle__AffiliationSlideImageContainer",
  componentId: "sc-qo27jb-4"
})(["position:relative;width:", ";height:", ";overflow:hidden;", " border-radius:", ";"], slideWidth, imageHeight, function (_ref) {
  var isBroken = _ref.isBroken;
  return isBroken ? css(["border:1px solid ", ";"], colorUsage.message.warning) : css(["border:1px solid ", ";"], colorUsage.imageBorder);
}, borderRadius.medium);
var AffiliationSlideImage = styled.img.withConfig({
  displayName: "AffiliationBlockSlideshowstyle__AffiliationSlideImage",
  componentId: "sc-qo27jb-5"
})(["display:block;width:auto;max-width:", ";height:auto;max-height:", ";margin:auto;"], slideWidth, imageHeight);
var AffiliationSlideDetails = styled.div.withConfig({
  displayName: "AffiliationBlockSlideshowstyle__AffiliationSlideDetails",
  componentId: "sc-qo27jb-6"
})(["position:absolute;bottom:0;left:0;display:flex;flex-direction:column;align-items:flex-start;justify-content:center;width:100%;height:72px;padding:", ";overflow:hidden;white-space:normal;border:1px solid ", ";border-radius:", ";"], getSpacing(1), colorUsage.affiliation, borderRadius.medium);
var ellipsisText = css(["overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"]);
var AffiliationSlideTitle = styled.div.withConfig({
  displayName: "AffiliationBlockSlideshowstyle__AffiliationSlideTitle",
  componentId: "sc-qo27jb-7"
})(["max-width:180px;", ";"], ellipsisText);
var AffiliationSlideOffer = styled.div.withConfig({
  displayName: "AffiliationBlockSlideshowstyle__AffiliationSlideOffer",
  componentId: "sc-qo27jb-8"
})(["display:flex;flex-direction:row;align-items:center;justify-content:center;color:", ";"], colorUsage.affiliation);
var AffiliationSlideStore = styled.span.withConfig({
  displayName: "AffiliationBlockSlideshowstyle__AffiliationSlideStore",
  componentId: "sc-qo27jb-9"
})(["width:115px;", ";"], ellipsisText);
var AffiliationSlidePrice = styled.span.withConfig({
  displayName: "AffiliationBlockSlideshowstyle__AffiliationSlidePrice",
  componentId: "sc-qo27jb-10"
})(["width:65px;text-align:right;"]);
var AffiliationSlideNoOffer = styled.span.withConfig({
  displayName: "AffiliationBlockSlideshowstyle__AffiliationSlideNoOffer",
  componentId: "sc-qo27jb-11"
})(["color:", ";"], colorUsage.message.warning);
var AffiliationSlideWarning = styled.span.withConfig({
  displayName: "AffiliationBlockSlideshowstyle__AffiliationSlideWarning",
  componentId: "sc-qo27jb-12"
})(["position:absolute;top:", ";right:5px;"], getSpacing(1));
export { AffiliationSlide, AffiliationSlideDetails, AffiliationSlideImage, AffiliationSlideImageContainer, AffiliationSlideNoOffer, AffiliationSlideOffer, AffiliationSlidePrice, AffiliationSlideshow, AffiliationSlideshowTitle, AffiliationSlideStore, AffiliationSlideTitle, AffiliationSlideWarning, LoaderContainer };